import { EntityOperation, ServerOperationResult, Severity, ValidationMessageGroup } from '@msdk/definitions'

import { ApiError, AttachmentError } from '../core/errors'

const POSSIBLE_LABELS = [
  'LBL_ATTACHMENT_INVALID_EXTENSION',
  'LBL_ATTACHMENT_TOO_BIG',
  'LBL_ATTACHMENT_INVALID_CHARS',
  'LBL_ATTACHMENT_INVALID_STREAM',
  'LBL_ATTACHMENT_SUSPICIOUS_STREAM',
  'LBL_ATTACHMENT_EMPTY',
]

const LABEL_MESSAGE_ASSOCIATION: Record<string, string> = {
  LBL_ATTACHMENT_INVALID_EXTENSION: 'FRM_ATTACHMENT_INVALID_EXTENSION',
  LBL_ATTACHMENT_TOO_BIG: 'FRM_ATTACHMENT_TOO_BIG',
  LBL_ATTACHMENT_INVALID_CHARS: 'FRM_ATTACHMENT_INVALID_CHARS',
  LBL_ATTACHMENT_INVALID_STREAM: 'FRM_ATTACHMENT_INVALID_STREAM',
  LBL_ATTACHMENT_SUSPICIOUS_STREAM: 'FRM_ATTACHMENT_SUSPICIOUS_STREAM',
  LBL_ATTACHMENT_EMPTY: 'FRM_ATTACHMENT_EMPTY',
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isAttachmentError(errorData: any) {
  const casted = errorData as AttachmentError
  return POSSIBLE_LABELS.includes(casted?.idml)
}

export function handleError(err: ApiError, entityId: string): EntityOperation | undefined {
  if (err.status === 400 && isAttachmentError(err.response)) {
    const errorObj = err.response as AttachmentError
    const result: EntityOperation = {
      entities: [],
      messages: { entities: [] },
      metadataList: [],
      result: ServerOperationResult.Failure,
    }
    const errorMessage: ValidationMessageGroup = {
      id: entityId,
      items: {},
    }
    errorMessage.items[errorObj.fieldName] = {
      messages: [
        {
          code: LABEL_MESSAGE_ASSOCIATION[errorObj.idml],
          description: errorObj.message,
          idml: errorObj.idml,
          type: Severity.Error,
          params: [errorObj.fileName],
        },
      ],
      rows: [],
    }

    result.messages.entities.push(errorMessage)
    return result
  }

  return undefined
}
